/*
  Veloura offer countdown.

  Two modes, chosen per block in the theme editor:

    fixed    counts to a real end timestamp rendered by Liquid. Every visitor
             sees the same deadline; the bar removes itself when it passes.
    rolling  starts a fresh window for each visitor the first time they see
             the bar, kept in localStorage, and restarts when it hits zero.

  Dawn re-renders the product info block whenever the quantity or variant
  changes, which replaces these nodes. So the tick reads the DOM fresh each
  second rather than holding element references, and one interval drives every
  bar on the page.
*/
(function () {
  var SELECTOR = '[data-lv-countdown]';

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function nowSeconds() {
    return Math.floor(Date.now() / 1000);
  }

  function readStore(key) {
    try {
      var v = parseInt(window.localStorage.getItem(key), 10);
      return isNaN(v) ? 0 : v;
    } catch (e) {
      return 0;
    }
  }

  function writeStore(key, value) {
    try {
      window.localStorage.setItem(key, String(value));
    } catch (e) {
      /* storage unavailable: the bar still works for this page view */
    }
  }

  function endFor(bar) {
    var mode = bar.getAttribute('data-mode');
    var now = nowSeconds();

    if (mode !== 'rolling') {
      return parseInt(bar.getAttribute('data-end'), 10) || 0;
    }

    var key = bar.getAttribute('data-key');
    var hours = parseFloat(bar.getAttribute('data-hours')) || 24;
    var end = readStore(key);
    if (end <= now) {
      end = now + Math.round(hours * 3600);
      writeStore(key, end);
    }
    return end;
  }

  function render(bar) {
    var clock = bar.querySelector('[data-lv-countdown-clock]');
    if (!clock) return;

    var end = endFor(bar);
    var remaining = end - nowSeconds();

    if (remaining <= 0) {
      if (bar.getAttribute('data-mode') === 'rolling') {
        // Window over: start the next one on the following tick.
        writeStore(bar.getAttribute('data-key'), 0);
        return;
      }
      bar.remove();
      return;
    }

    var days = Math.floor(remaining / 86400);
    var hours = Math.floor((remaining % 86400) / 3600);
    var minutes = Math.floor((remaining % 3600) / 60);
    var seconds = remaining % 60;

    var text = days > 0
      ? days + 'd ' + pad(hours) + ':' + pad(minutes) + ':' + pad(seconds)
      : pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);

    // Only touch the DOM when the display actually changes. Writing text is
    // itself a mutation, so an unconditional write would re-trigger the
    // observer below on every tick.
    if (clock.textContent !== text) clock.textContent = text;
  }

  function tick() {
    var bars = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < bars.length; i++) render(bars[i]);
  }

  tick();
  setInterval(tick, 1000);

  // Paint immediately after Dawn re-renders the product info, instead of
  // waiting up to a second. Only reacts when a whole new bar element arrives,
  // never to text changes inside an existing one.
  function addsBar(node) {
    if (node.nodeType !== 1) return false;
    if (node.matches && node.matches(SELECTOR)) return true;
    return !!(node.querySelector && node.querySelector(SELECTOR));
  }

  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (addsBar(added[j])) {
            tick();
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) tick();
  });
})();
